/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Tab_DebtsInputs */

const vi_report_tab_debts = /** @type {(inputs: Report_Tab_DebtsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ`)
};

/**

* @param {Report_Tab_DebtsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_tab_debts = /** @type {((inputs?: Report_Tab_DebtsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Tab_DebtsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_tab_debts(inputs)
});